export default __webpack_public_path__ + "static/media/pantry2-before2-1024w.d4e393d2.webp";